import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { useParams, Link as RouterLink } from 'react-router-dom';
import starFill from '@iconify/icons-eva/star-fill';
import linkFill from '@iconify/icons-eva/link-fill';
import starOutline from '@iconify/icons-eva/star-outline';
import facebookFill from '@iconify/icons-eva/facebook-fill';
import roundLabelImportant from '@iconify/icons-ic/round-label-important';

// material
import { styled } from '@material-ui/core/styles';
import { Box, Link, Tooltip, Typography, Stack, Checkbox } from '@material-ui/core';
// redux
import { useDispatch, useSelector } from '../../../redux/store';
// utils
import { fDate } from '../../../utils/formatTime';
import createAvatar from '../../../utils/createAvatar';
// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
//
import { MAvatar, MHidden } from '../../@material-extend';
import Label from '../../Label';
import ContactItemAction from './ContactItemAction';
import { objectID } from '../../../utils/objectID';
import ShareIcon from '@mui/icons-material/Share';
import apiContact from './../../../api/contact'
import { useSnackbar } from 'notistack5';
import AlertFormListChat from '../phonebook/alert/AlertFormListChat';
import { useState } from 'react';
import { newMessageFacebook, newMessageFacebookBySelectedContact, newMessageZalo, newMessageZaloBySelectedContact } from '../../../redux/slices/chat';
import { DialogAnimate } from '../../animate';
import DialogSendMessage from './DialogSendMessage';
// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(0, 2),
  color: theme.palette.text.secondary,
  backgroundColor: theme.palette.background.neutral,
  borderBottom: `1px solid ${theme.palette.divider}`,
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    alignItems: 'center'
  },
  '&:hover': {
    zIndex: 999,
    position: 'relative',
    boxShadow: theme.customShadows.z24,
    '& .showActions': { opacity: 1 }
  }
}));

const WrapStyle = styled(Link)(({ theme }) => ({
  minWidth: 0,
  display: 'flex',
  padding: theme.spacing(2, 0),
  transition: theme.transitions.create('padding')
}));

// ----------------------------------------------------------------------

const linkTo = (params, mailId) => {
  const { systemLabel, customLabel } = params;
  const baseUrl = PATH_DASHBOARD.mail.root;

  if (systemLabel) {
    return `${baseUrl}/${systemLabel}/${mailId}`;
  }
  if (customLabel) {
    return `${baseUrl}/label/${customLabel}/${mailId}`;
  }
  return baseUrl;
};

ContactItem.propTypes = {
  mail: PropTypes.object.isRequired,
  isDense: PropTypes.bool,
  isSelected: PropTypes.bool.isRequired,
  onDeselect: PropTypes.func,
  onSelect: PropTypes.func
};

export default function ContactItem({ setContactSelected, loadListContact, contact, isDense, isSelected, onSelect, onDeselect, ...other }) {
  const params = useParams();
  // const { labels } = useSelector((state) => state.mail);
  //const isAttached = contact.length > 0;
  const [listChatContact, setListChatContact] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [openDialog, setOpenDialog] = useState(false);
  const handleChangeCheckbox = (event) => (event.target.checked ? onSelect() : onDeselect());
  const { doCall } = useSelector(state => state.janus);
  const dispatch = useDispatch();
  const [isOpenModalSend, setIsOpenModalSend] = useState(false);
  const handleCloseModalSend = () => {
    setIsOpenModalSend(false);
  }

  const handleOpenModalSend = (phone) => {
    setIsOpenModalSend(true);
  }

  const handleCall = (phoneNumber) => {
    doCall(phoneNumber)
  }
  const handleDelete = async (contactId) => {
    try {

      const res_add_support_dept = await apiContact.delete_force({ contactId: contactId });
      enqueueSnackbar("Xóa thành công", { variant: 'success' });
      loadListContact();
    } catch (error) {
      enqueueSnackbar(error.response.data.message[0], { variant: 'error' });
    }
  }
  const handleChat = async (contact) => {
    try {

      const res_add_support_dept = await apiContact.find_list_chat({ id: contact?.id, uid_zl: contact?.uid_zl, uid_fb: contact?.uid_fb });
      console.log(res_add_support_dept.data.data.length)
      if (res_add_support_dept.data.data.length > 1) {
        setOpenDialog(true);
        setListChatContact(res_add_support_dept.data.data)
      } else if (res_add_support_dept.data.data.length === 1) {
        const contact = res_add_support_dept.data.data[0];
        console.log()
        if (contact.channel === "facebook") {

          dispatch(newMessageFacebookBySelectedContact(contact));
        }
        if (contact.channel === "zalo") {
          dispatch(newMessageZaloBySelectedContact(contact));
        }
        setListChatContact(res_add_support_dept.data.data)
      } else {
        enqueueSnackbar("Không có cuộc trò chuyện", { variant: 'warning' });
      }
      // enqueueSnackbar("Xóa thành công", { variant: 'success' });
    } catch (error) {
      enqueueSnackbar(error.response.data.message[0], { variant: 'error' });
    }
  }
  const onCloseDialog = () => {
    setOpenDialog(false);
  }

  return (
    <RootStyle
      // sx={{
      //   ...(!mail.isUnread && {
      //     color: 'text.primary',
      //     backgroundColor: 'background.paper'
      //   }),
      sx={{
        color: 'text.primary',
        backgroundColor: 'background.paper',
        ...(isSelected && { bgcolor: 'action.selected' })
      }}
      {...other}
    >
      <MHidden width="mdDown">
        <Stack direction="row" sx={{ mr: 2 }}>
          <Checkbox checked={isSelected} onChange={handleChangeCheckbox} />
          {/* <Tooltip title="Starred">
            <Checkbox
              color="warning"
              defaultChecked={mail.isStarred}
              icon={<Icon icon={starOutline} />}
              checkedIcon={<Icon icon={starFill} />}
            />
          </Tooltip>
          <Tooltip title="Important">
            <Checkbox
              color="warning"
              defaultChecked={mail.isImportant}
              checkedIcon={<Icon icon={roundLabelImportant} />}
              icon={<Icon icon={roundLabelImportant} />}
            />
          </Tooltip> */}
        </Stack>
      </MHidden>

      <WrapStyle
        color="inherit"
        underline="none"
        onClick={() => setContactSelected(objectID(contact._id))}
        // component={RouterLink}
        // to={linkTo(params, contact.name)}
        sx={{ cursor: "pointer", display: 'flex', ...(isDense && { py: 1 }) }}
      >
        {/* <MAvatar
          alt={mail.from.name}
          src={mail.from.avatar}
          color={createAvatar(mail.from.name).color}
          sx={{ width: 32, height: 32 }}
        >
          {createAvatar(mail.from.name).name}
        </MAvatar> */}

        <Box
          sx={{
            ml: 2,
            minWidth: 0,
            alignItems: 'center',
            display: { md: 'flex' }
          }}
        >
          <Tooltip placement='bottom-start' title="Tên danh bạ">
            <Typography
              variant="body2"
              noWrap
              sx={{
                pr: 2,
                minWidth: 200,
                // fontWeight: 'fontWeightBold'
                // ...(!mail.isUnread && { fontWeight: 'fontWeightBold' })
              }}
            >
              {contact.name}
            </Typography>
          </Tooltip>
          <Tooltip placement='bottom-start' title="Số diện thoại">
            <Typography noWrap variant="body2" sx={{ pr: 2 }} >
              <Box component="span"
              // sx={{ fontWeight: 'fontWeightBold' }}
              >
                {contact.phone}
              </Box>
            </Typography>
          </Tooltip>
          <Tooltip placement='bottom-start' title="Ngày tạo">
            <Typography noWrap variant="body2" sx={{ pr: 2 }} >
              <Box component="span"
              // sx={{ fontWeight: 'fontWeightBold' }}
              >
                {contact.created_at}
              </Box>
            </Typography>
          </Tooltip>
          <MHidden width="mdDown">
            <Tooltip title="Tạo bởi">
              <Box sx={{ display: 'flex' }}>
                <Label
                  sx={{
                    mx: 0.5,
                    textTransform: 'capitalize',
                    bgcolor: "#1890FF",
                    color: (theme) => theme.palette.getContrastText("#1890FF")
                  }}
                >
                  {contact.assigned_by_name ? contact.assigned_by_name : contact.created_by_name}
                </Label>
              </Box>
            </Tooltip>
          </MHidden>
          <MHidden width="mdDown">
            <Tooltip title="Tạo từ">
              <Box sx={{ display: 'flex' }}>
                <Label
                  sx={{
                    mx: 0.5,
                    textTransform: 'capitalize',
                    bgcolor: "#4a52b0",
                    color: (theme) => theme.palette.getContrastText("#1890FF")
                  }}
                >
                  {contact.from}
                </Label>
              </Box>
            </Tooltip>
          </MHidden>

          <Typography
            variant="caption"
            sx={{
              flexShrink: 0,
              minWidth: 120,
              textAlign: 'right',
              // ...(!mail.isUnread && { fontWeight: 'fontWeightBold' })
              fontWeight: 'fontWeightBold'
            }}
          >
            {/* {fDate(mail.assignedAt)} */}
            {contact.from.address}
          </Typography>
        </Box>
      </WrapStyle>

      <ContactItemAction handleOpenModalSend={() => handleOpenModalSend()} handleCall={() => handleCall(contact.phone)} handleChat={() => handleChat(contact)} handleDelete={() => handleDelete(objectID(contact._id))} className="showActions" />
      <AlertFormListChat listChatContact={listChatContact} open={openDialog} onClose={() => onCloseDialog(false)}></AlertFormListChat>

      <DialogAnimate fullWidth maxWidth="md" open={isOpenModalSend} onClose={handleCloseModalSend}>
        <DialogSendMessage contact={contact} isOpenModalSend={isOpenModalSend} handleCloseModalSend={handleCloseModalSend}></DialogSendMessage>
      </DialogAnimate>
    </RootStyle>
  );
}
